import { ReviewStatus } from '@/models/review.model';

export const statusFilterOptions = [
  { label: 'All', value: ReviewStatus.ALL },
  { label: 'Pending', value: ReviewStatus.PENDING },
  { label: 'Approved', value: ReviewStatus.APPROVED },
];
